import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

export const CustomerList = () => {
  const [customer, setCustomer] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const customersPerPage = 10;
  const [pageNumberLimit] = useState(5);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";

      try {
        const apiToken = sessionStorage.getItem("api_token");

        if (!apiToken) {
          console.error("API Token not found in session storage");
          return;
        }

        const response = await fetch(`${apiUrl}/customer-list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            su_id: 1,
            api_token: apiToken,
            trans_from: "SUPER_ADMIN",
          }),
        });

        if (response.ok) {
          const data = await response.json();
          setCustomer(data.data.reverse());
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error occurred while fetching data", error);
      }
    };

    fetchData();
  }, []);

  const indexOfLastCustomer = currentPage * customersPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;

  // Filter customers based on search query
  const filteredCustomers = customer.filter((row) =>
    row.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.mobile.toString().includes(searchQuery) ||
    row.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.pin_code.toString().includes(searchQuery)
  );

  const currentCustomers = filteredCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);

  const totalPages = Math.ceil(filteredCustomers.length / customersPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleClick = (event) => {
    const selectedPage = Number(event.target.getAttribute("id"));
    setCurrentPage(selectedPage);
  };

  const handleNextBtn = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handlePrevBtn = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const renderPageNumbers = () => {
    const pages = [];

    if (currentPage > 1) {
      pages.push(
        <li key="prev" className="page-item">
          <a onClick={handlePrevBtn} className="page-link">
            Previous
          </a>
        </li>
      );
    }

    const startPage = Math.max(currentPage - Math.floor(pageNumberLimit / 2), 1);
    const endPage = Math.min(startPage + pageNumberLimit - 1, totalPages);

    if (startPage > 1) {
      pages.push(
        <li key={1} id={1} onClick={handleClick} className="page-item">
          <a className="page-link">1</a>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="dots1" className="page-item disabled">
            <a className="page-link">...</a>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          id={i}
          onClick={handleClick}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <a id={i} className="page-link">{i}</a>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="dots2" className="page-item disabled">
            <a className="page-link">...</a>
          </li>
        );
      }
      pages.push(
        <li key={totalPages} id={totalPages} onClick={handleClick} className="page-item">
          <a className="page-link">{totalPages}</a>
        </li>
      );
    }

    if (currentPage < totalPages) {
      pages.push(
        <li key="next" className="page-item">
          <a onClick={handleNextBtn} className="page-link">
            Next
          </a>
        </li>
      );
    }

    return pages;
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value); // Update search query
    setCurrentPage(1); // Reset to first page when searching
  };

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">Customer List</h6>
                </div>
                  {/* Search Box */}
                  <div style={{ display: "flex", justifyContent: "end" }}>
                  <div className="mb-3 col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Gender</th>
                          <th>Mobile NO</th>
                          <th>Email</th>
                          <th>Address</th>
                          <th>Pin Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(currentCustomers) && currentCustomers.length > 0 ? (
                          currentCustomers.map((customer) => (
                            <tr key={customer.id}>
                              <td>{customer.name}</td>
                              <td>{customer.gender}</td>
                              <td>{customer.mobile}</td>
                              <td>{customer.email}</td>
                              <td>{customer.address}</td>
                              <td>{customer.pin_code}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <nav>
                      <ul className="pagination justify-content-center" style={{ float: "right" }}>
                        {renderPageNumbers()}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};
